// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2Snr1","title":"Info_title__U1D3f","selects":"Info_selects__39qu5","requiredAsterisk":"Info_requiredAsterisk__1dT0n"};